import noUiSlider from 'nouislider';

export default (el, minEl, maxEl, options = {}) => noUiSlider.create(el, {
  connect: true,
  start: [20, 80],
  range: {
    min: 0,
    max: 100,
  },
  ...options,
});
